import { MdOutlineSearchOff } from "react-icons/md";
import Typography from "../../../../componentsNew/Typography";

export default function SemDadosAnalise ({texto}) {
    return(
        <div className="justify-center items-center flex flex-col">
            <MdOutlineSearchOff className="w-[1.982em] h-[1.982em] text-grey-light"/>
            <Typography className="text-center mt-7" component="body-titulo">{texto.includes('termos inapropriados') ? "Ops! Ocorreu um erro" : "Sem resultados"}</Typography>
            <Typography className="text-center mt-3" component="body-card">{texto}</Typography>
        </div>
    )
}